import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// ✅ Define the shape of your slice's state
export interface ThemeState {
  mode: 'light' | 'dark';
}

// ✅ Get saved theme from localStorage with error handling
const getSavedTheme = (): 'light' | 'dark' => {
  try {
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light' || savedTheme === 'dark') {
      return savedTheme;
    }
  } catch (error) {
    console.warn('Error reading theme from localStorage:', error);
  }
  return 'light'; // Default fallback
};

// ✅ Initial state with saved theme
const initialState: ThemeState = {
  mode: getSavedTheme(),
};

// ✅ Create the slice with typed reducers
const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'dark' ? 'light' : 'dark';
      // Save to localStorage
      try {
        localStorage.setItem('theme', state.mode);
      } catch (error) {
        console.warn('Error saving theme to localStorage:', error);
      }
    },
    setTheme: (state, action: PayloadAction<'light' | 'dark'>) => {
      state.mode = action.payload;
      // Save to localStorage
      try {
        localStorage.setItem('theme', action.payload);
      } catch (error) {
        console.warn('Error saving theme to localStorage:', error);
      }
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
